/* MIEN — worn submission flow. Reuses the shared window.MIEN Supabase client
   (same project URL + anon key); uploads photos to the "worn-photos" bucket and
   inserts a pending row into "worn_submissions". RLS protects the data. */
(function () {
  function init() {
    var root = document.querySelector('.wsub');
    if (!root) return;

    var boot = document.getElementById('wsub-boot');
    var authBox = document.getElementById('wsub-auth');
    var formBox = document.getElementById('wsub-formwrap');

    if (!window.MIEN || !MIEN.ready() || !MIEN.sb) {
      if (boot) boot.textContent = 'submissions are temporarily unavailable. please try again shortly.';
      return;
    }
    var sb = MIEN.sb;
    var photos = []; // Depop-style: the chosen File objects, first = cover

    // ---------- view switching ----------
    function showAuth() { if (boot) boot.hidden = true; authBox.hidden = false; formBox.hidden = true; }
    function showForm(u) {
      if (boot) boot.hidden = true;
      authBox.hidden = true; formBox.hidden = false;
      var who = document.getElementById('wsub-who');
      if (who) who.textContent = 'signed in as ' + (u.email || 'member');
    }
    function refresh() {
      MIEN.user().then(function (u) { if (u) showForm(u); else showAuth(); });
    }

    // ---------- auth gate ----------
    var mode = 'signup';
    var tabs = root.querySelectorAll('.wsub-tab');
    var authBtn = document.getElementById('wsub-authbtn');
    tabs.forEach(function (t) {
      t.addEventListener('click', function () {
        mode = t.getAttribute('data-mode');
        tabs.forEach(function (x) { x.classList.toggle('is-on', x === t); });
        if (authBtn) authBtn.textContent = mode === 'signup' ? 'create account' : 'sign in';
        var pass = document.getElementById('wsub-pass');
        if (pass) pass.setAttribute('autocomplete', mode === 'signup' ? 'new-password' : 'current-password');
      });
    });

    function authMsg(text, isErr) {
      var m = document.getElementById('wsub-authmsg');
      if (!m) return;
      m.hidden = false; m.textContent = text;
      m.classList.toggle('is-err', !!isErr);
    }

    var authForm = document.getElementById('wsub-authform');
    if (authForm) authForm.addEventListener('submit', function (e) {
      e.preventDefault();
      var email = (document.getElementById('wsub-email').value || '').trim();
      var pass = document.getElementById('wsub-pass').value || '';
      if (!email || pass.length < 6) { authMsg('enter an email and a password (6+ characters).', true); return; }
      authBtn.disabled = true; authMsg(mode === 'signup' ? 'creating account…' : 'signing in…', false);
      var p = mode === 'signup' ? MIEN.signUp(email, pass) : MIEN.signIn(email, pass);
      p.then(function (r) {
        authBtn.disabled = false;
        if (r && r.error) { authMsg(r.error.message || 'could not authenticate.', true); return; }
        // signUp with email-confirmation on returns no session yet
        if (mode === 'signup' && r && r.data && !r.data.session) {
          authMsg('account created — check your email to confirm, then come back.', false);
          return;
        }
        refresh();
      }).catch(function () { authBtn.disabled = false; authMsg('something went wrong. try again.', true); });
    });

    var signOut = document.getElementById('wsub-signout');
    if (signOut) signOut.addEventListener('click', function () { MIEN.signOut().then(refresh); });

    MIEN.onChange(function () { refresh(); });

    // ---------- depop-style photo grid ----------
    var fileInput = document.getElementById('f-photos');
    var fileHint = document.getElementById('f-photos-hint');
    var photoGrid = document.getElementById('wsub-photos');
    var addTile = document.getElementById('wsub-add');

    function renderPhotos() {
      if (!photoGrid) return;
      Array.prototype.slice.call(photoGrid.querySelectorAll('.wsub-ph')).forEach(function (t) {
        var u = t.getAttribute('data-url'); if (u) URL.revokeObjectURL(u);
        t.remove();
      });
      photos.forEach(function (file, i) {
        var url = URL.createObjectURL(file);
        var tile = document.createElement('div');
        tile.className = 'wsub-ph';
        tile.setAttribute('data-url', url);
        tile.innerHTML =
          '<img src="' + url + '" alt="">' +
          (i === 0 ? '<span class="wsub-ph-cover">cover</span>' : '') +
          '<button type="button" class="wsub-ph-x" data-idx="' + i + '" aria-label="remove photo">&times;</button>';
        photoGrid.insertBefore(tile, addTile);
      });
      if (fileHint) fileHint.textContent = photos.length
        ? (photos.length + (photos.length === 1 ? ' photo · first is the cover' : ' photos · first is the cover'))
        : 'clear, well-lit shots sell. first photo is the cover.';
    }

    if (fileInput) fileInput.addEventListener('change', function () {
      var picked = fileInput.files ? Array.prototype.slice.call(fileInput.files) : [];
      picked.forEach(function (f) {
        if (f.type.indexOf('image/') !== 0) return;
        var dup = photos.some(function (p) { return p.name === f.name && p.size === f.size; });
        if (!dup) photos.push(f);
      });
      fileInput.value = ''; // let the same file be re-added after a removal
      renderPhotos();
    });
    if (photoGrid) photoGrid.addEventListener('click', function (e) {
      var x = e.target.closest('.wsub-ph-x');
      if (!x) return;
      var idx = parseInt(x.getAttribute('data-idx'), 10);
      if (idx >= 0 && idx < photos.length) { photos.splice(idx, 1); renderPhotos(); }
    });

    // ---------- submit ----------
    function formMsg(text, isErr) {
      var m = document.getElementById('wsub-formmsg');
      if (!m) return;
      m.hidden = false; m.textContent = text;
      m.classList.toggle('is-err', !!isErr);
    }
    function val(id) { var el = document.getElementById(id); return el ? (el.value || '').trim() : ''; }
    function safeName(name) { return (name || 'photo').replace(/[^a-zA-Z0-9.\-_]/g, '_').slice(-80); }
    function uuid() {
      if (window.crypto && crypto.randomUUID) return crypto.randomUUID();
      return 'xxxxxxxxxxxx4xxxyxxx'.replace(/[xy]/g, function (c) {
        var r = (Math.random() * 16) | 0, v = c === 'x' ? r : (r & 0x3) | 0x8; return v.toString(16);
      });
    }

    var form = document.getElementById('wsub-form');
    var submitBtn = document.getElementById('wsub-submit');
    var doneBox = document.getElementById('wsub-done');

    if (form) form.addEventListener('submit', function (e) {
      e.preventDefault();
      var item = val('f-item');
      var files = photos.slice();
      if (!item) { formMsg('item name is required.', true); return; }
      if (!files.length) { formMsg('add at least one photo.', true); return; }

      submitBtn.disabled = true;
      formMsg('uploading photos…', false);

      MIEN.user().then(function (u) {
        if (!u) { submitBtn.disabled = false; formMsg('your session expired — sign in again.', true); refresh(); return; }

        // upload each photo, collect public URLs
        var urls = [];
        var chain = Promise.resolve();
        files.forEach(function (file) {
          chain = chain.then(function () {
            var path = u.id + '/' + uuid() + '-' + safeName(file.name);
            return sb.storage.from('worn-photos').upload(path, file, { cacheControl: '3600', upsert: false })
              .then(function (res) {
                if (res && res.error) throw res.error;
                var pub = sb.storage.from('worn-photos').getPublicUrl(path);
                urls.push(pub.data.publicUrl);
              });
          });
        });

        chain.then(function () {
          formMsg('saving submission…', false);
          var price = val('f-price');
          var row = {
            seller_id: u.id,
            item_name: item,
            original_brand: val('f-brand') || null,
            size: val('f-size') || null,
            condition: val('f-cond') || null,
            measurements: val('f-meas') || null,
            asking_price: price ? parseFloat(price) : null,
            description: val('f-desc') || null,
            photo_urls: urls,
            seller_name: val('f-name') || null,
            payout_method: val('f-paym') || null,
            payout_handle: val('f-payh') || null,
            seller_notes: val('f-notes') || null,
            status: 'pending'
          };
          return sb.from('worn_submissions').insert(row);
        }).then(function (r) {
          submitBtn.disabled = false;
          if (r && r.error) { formMsg(r.error.message || 'could not save. try again.', true); return; }
          form.reset();
          photos = []; renderPhotos();
          formMsg('', false);
          document.getElementById('wsub-formmsg').hidden = true;
          if (doneBox) doneBox.hidden = false;
          form.hidden = true;
        }).catch(function (err) {
          submitBtn.disabled = false;
          formMsg((err && err.message) ? err.message : 'upload failed. try again.', true);
        });
      });
    });

    // ---------- boot ----------
    refresh();
  }

  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
})();
